<div class="header">
  <div class="title">{{ "aircraft" | translate }}</div>
</div>

<div class="content">
  <div class="form" [formGroup]="searchForm">
    <mat-form-field floatLabel="always">
      <mat-label>{{ "products.labels.commercialName" | translate }}</mat-label>
      <mat-select
        formControlName="aircraftTechnicalName"
        (selectionChange)="onFilterChange($event.value, 'commercialName')"
        required>
        @for (aircraft of aircrafts; track $index) {
          <mat-option [value]="aircraft.commercialName">
            {{ aircraft.commercialName }}
          </mat-option>
        }
      </mat-select>
      <mat-error>{{ "products.labels.aircraftError" | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field floatLabel="always">
      <mat-label>{{ "products.labels.aircraftVersion" | translate }}</mat-label>
      <mat-select formControlName="aircraftVersion" (selectionChange)="onFilterChange($event.value, 'version')">
        <mat-select-trigger>{{ searchForm.controls.aircraftVersion.value }}</mat-select-trigger>
        <mat-option value="">All</mat-option>
        @for (version of aircraftVersions; track $index) {
          <mat-option [value]="version"> {{ aircraftTechnicalName }} {{ version }} </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field floatLabel="always">
      <mat-label>{{ "products.labels.productType" | translate }}</mat-label>
      <mat-select formControlName="productType" (selectionChange)="onFilterChange($event.value, 'productType')">
        <mat-select-trigger>
          {{ searchForm.controls.productType.value }}
        </mat-select-trigger>
        @for (option of searchProductsService.optionsByCategory.productType | keyvalue; track option.key) {
          <mat-option [value]="option.key"> {{ option.key || "All" }} ({{ option.value }}) </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field floatLabel="always">
      <mat-label>{{ "products.labels.manualCode" | translate }}</mat-label>
      <mat-select formControlName="manualCode" (selectionChange)="onFilterChange($event.value, 'manualCode')">
        <mat-select-trigger>
          {{ searchForm.controls.manualCode.value }}
        </mat-select-trigger>
        @for (option of searchProductsService.optionsByCategory.manualCode | keyvalue; track option.key) {
          <mat-option [value]="option.key"> {{ option.key || "All" }} ({{ option.value }}) </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field floatLabel="always">
      <mat-label>{{ "products.labels.lang" | translate }}</mat-label>
      <mat-select formControlName="lang" (selectionChange)="onFilterChange($event.value, 'lang')">
        <mat-select-trigger>
          {{ searchForm.controls.lang.value?.toUpperCase() }}
        </mat-select-trigger>
        @for (option of searchProductsService.optionsByCategory.lang | keyvalue; track option.key) {
          <mat-option [value]="option.key"> {{ option.key?.toUpperCase() || "All" }} ({{ option.value }}) </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field floatLabel="always">
      <mat-label>{{ "products.labels.manualCategory" | translate }}</mat-label>
      <mat-select formControlName="manualCategory" (selectionChange)="onFilterChange($event.value, 'manualCategory')">
        <mat-select-trigger>
          {{ searchForm.controls.manualCategory.value }}
        </mat-select-trigger>
        @for (option of searchProductsService.optionsByCategory.manualCategory | keyvalue; track option.key) {
          <mat-option [value]="option.key"> {{ option.key || "All" }} ({{ option.value }}) </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="footer">
    <button class="button-reset" mat-raised-button (click)="reset()">
      {{ "button.reset" | translate }}
    </button>
    <button class="button-close" mat-raised-button color="primary" (click)="close()">
      {{ "button.close" | translate }}
    </button>
  </div>
</div>
